<template>
  <div class="dp-search-bar">
    <fpui-button
      @click="toggleSearchModal"
      icon="fp4 fp4-magnifying-glass"
      color="grey"
      icon-left
      noshadow
      auto-width
    >
      <div>{{ $t('searchbar.search') }}</div>
      <div class="keyboard-shortcut">{{ keyboardShortcut }}</div>
    </fpui-button>
  </div>
</template>

<script>
import SearchModal from '@/shared/components/searchbar/SearchModal'

export default {
  data () {
    return {
      modal: null
    }
  },
  computed: {
    isMac () {
      // Modern approach using navigator.userAgentData (when available)
      if (navigator.userAgentData) { return navigator.userAgentData.platform === 'macOS' }

      // Fallback to userAgent for older browsers
      return /Mac|iPhone|iPad|iPod/.test(navigator.userAgent)
    },
    keyboardShortcut () {
      return this.isMac ? '⌘K' : 'Ctrl+K'
    }
  },
  mounted () {
    window.addEventListener('keydown', this.handleShortcut)
  },
  beforeUnmount () {
    window.removeEventListener('keydown', this.handleShortcut)
  },
  methods: {
    handleShortcut (e) {
      const cmdOrCtrl = this.isMac ? e.metaKey : e.ctrlKey

      // CMD+K or CTRL+K
      if (cmdOrCtrl && e.key.toLowerCase() === 'k') {
        e.preventDefault()
        this.toggleSearchModal()
      }
    },
    toggleSearchModal () {
      if (this.modal) {
        this.$modal.hide(this.modal)
        this.modal = null
        return
      }
      this.$modal.show(SearchModal, {}, {
        height: 'auto',
        width: 600,
        draggable: true,
        adaptive: false,
        shiftY: 0,
        styles: {
          'border-radius': '14px',
          'background-color': 'transparent',
          'backdrop-filter': 'blur(8px)'
        },
        onClose: () => (this.modal = null),
        onBeforeOpen: (event) => (this.modal = event.name)
      }, {
        name: 'search-modal'
      })
    }
  }
}
</script>

<style lang="less">
.dp-search-bar {
  margin-right: 10px;
  .button-container {
    button {
      &.btn.fpui-button.v4 {
        background-color: transparent;
        border: 1px solid @grey;
        color: @grey;
        font-weight: 700;
      }
      .btn-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 15px;
        width: 100%;
        .keyboard-shortcut {
          color: @grey-chart;
        }
      }
    }
  }
}
</style>
